import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Wide%20panoramic%20display%20of%20colorful%20sneaker%20wall%20and%20organized%20fashion%20clothing%20rack%20in%20modern%20sunlit%20boutique%2C%20warm%20ambient%20lighting%20from%20above%2C%20clean%20organized%20retail%20display%2C%20editorial%20fashion%20photography%2C%20sophisticated%20retail%20atmosphere%2C%20horizontal%20wide%20composition%2C%20soft%20natural%20light%20streaming%2C%20earthy%20warm%20tones%20with%20sage%20green%20accents&width=1920&height=800&seq=cta-panorama-oopbuy-v3&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/50" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="lg:max-w-[50%]">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white lowercase leading-none mb-6">
              {t("cta_title")}
            </h2>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-white text-foreground-900 font-semibold rounded-full text-sm md:text-base hover:bg-foreground-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>{t("cta_button")}</span>
              <span className="w-6 h-6 bg-foreground-900 rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs w-3 h-3 flex items-center justify-center"></i>
              </span>
            </a>
          </div>

          <div className="lg:text-right">
            <p className="text-white/80 text-sm md:text-base leading-relaxed">
              {t("cta_right_text1")}
            </p>
            <p className="text-white/80 text-sm md:text-base leading-relaxed">
              {t("cta_right_text2")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}